export type ThresholdProgressBarVariant = 'auto' | 'success' | 'warning' | 'error'

export type ThresholdProgressBarProps = {
    value: number
    variant?: ThresholdProgressBarVariant
    className?: string
    trackClassName?: string
    'aria-label'?: string
}

export type ThresholdProgressBarResolvedVariant = Exclude<ThresholdProgressBarVariant, 'auto'>

export const clampThresholdPercent = (value: number) => Math.min(100, Math.max(0, value))

/** Пороги как в adminstat user-details: >=80 success, >=60 warning. */
export const getThresholdVariant = (percent: number): ThresholdProgressBarResolvedVariant => {
    if (percent >= 80) return 'success'
    if (percent >= 60) return 'warning'
    return 'error'
}

export const thresholdBarClass: Record<ThresholdProgressBarResolvedVariant, string> = {
    success: 'bg-success',
    warning: 'bg-warning',
    error: 'bg-error',
}

export const thresholdTextClass: Record<ThresholdProgressBarResolvedVariant, string> = {
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-error',
}
